export default __webpack_public_path__ + "static/cruiselogo_viking-579a2a2fb073d02fdee06d961972dc45.png";